if (!customElements.get('price-slider')) {
  class PriceSlider extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      requestAnimationFrame(() => this.init());
    }

    init() {
      this.track = this.querySelector('.price-slider__track');
      this.priceRange = this.parentElement?.querySelector('price-range');
      this.minLabel = this.querySelector('[filter-min-text]');
      this.maxLabel = this.querySelector('[filter-max-text]');
      this.currencySymbol = this.dataset.currencySymbol || '$';

      if (!this.track || !this.priceRange || !window.noUiSlider) return;

      this.minInput = this.priceRange.querySelector('[name="filter.v.price.gte"]');
      this.maxInput = this.priceRange.querySelector('[name="filter.v.price.lte"]');
      if (!this.minInput || !this.maxInput) return;

      this.rangeMin = this.parseValue(this.minInput.dataset.min) || 0;
      this.rangeMax = this.parseValue(this.maxInput.dataset.max || this.minInput.dataset.max) || 0;
      if (this.rangeMax <= this.rangeMin) return;

      const startMin = this.parseValue(this.minInput.value);
      const startMax = this.parseValue(this.maxInput.value);

      if (this.track.noUiSlider) this.track.noUiSlider.destroy();

      window.noUiSlider.create(this.track, {
        start: [startMin || this.rangeMin, startMax || this.rangeMax],
        connect: true,
        step: 1,
        range: {
          min: this.rangeMin,
          max: this.rangeMax,
        },
      });

      this.track.noUiSlider.on('update', (values) => this.updateLabels(values));
      this.track.noUiSlider.on('change', (values) => this.applyValues(values));
      this.track.noUiSlider.on('set', (values) => this.applyValues(values));
    }

    parseValue(value) {
      if (value === null || value === undefined || value === '') return null;
      const parsed = Number(String(value).replace(/[^0-9.-]/g, ''));
      return Number.isFinite(parsed) ? parsed : null;
    }

    displayValue(value) {
      return `${this.currencySymbol}${Math.round(Number(value)).toLocaleString()}`;
    }

    inputValue(value) {
      return String(Math.round(Number(value)));
    }

    updateLabels(values) {
      if (this.minLabel) this.minLabel.textContent = this.displayValue(values[0]);
      if (this.maxLabel) this.maxLabel.textContent = this.displayValue(values[1]);
    }

    applyValues(values) {
      const nextMin = Math.round(Number(values[0]));
      const nextMax = Math.round(Number(values[1]));
      const minValue = nextMin <= this.rangeMin ? '' : this.inputValue(nextMin);
      const maxValue = nextMax >= this.rangeMax ? '' : this.inputValue(nextMax);

      if (this.minInput.value === minValue && this.maxInput.value === maxValue) return;

      this.minInput.value = minValue;
      this.maxInput.value = maxValue;
      this.priceRange.setMinAndMaxValues?.();

      clearTimeout(this.submitTimer);
      this.submitTimer = setTimeout(() => {
        this.maxInput.dispatchEvent(new Event('input', { bubbles: true }));
      }, 150);
    }
  }

  customElements.define('price-slider', PriceSlider);
}